import * as React from 'react';
import { connect } from 'react-redux';
import { Breadcrumbs } from '../../components/Breadcrumbs/Breadcrumbs';
import { CollapsibleText } from '../../components/CollapsibleDropDown/CollapsibleText';
import { FurtherInfo } from '../../components/FurtherInfo/FurtherInfo';
import { PriceWithDiscount } from '../../components/Recommendation/PriceWithDiscount';
import { recommendationDescUnderImg } from '../../components/Recommendation/RecommendationDescUnderImg';
import RecommendationSection from '../../components/Recommendation/RecommendationSection';
import { OverviewPageHeader } from '../../components/OverviewPageHeader/OverviewPageHeader';
import { TrackComponent } from '../../components/TrackComponent';
import { IState } from '../../reducers';
import { ICompanyOverviewPageReducer } from '../../reducers/companyOverviewPage';
import { IPageDataReducer } from '../../reducers/pageData';
import { styles } from '../../components/Share/ShareArea/ShareArea';

interface StateProps {
    pageData: IPageDataReducer;
    companyOverview: ICompanyOverviewPageReducer;
}

type Props = StateProps;

export class CompanyOverviewPageClass extends React.Component<Props> {
    render() {
        const {
            breadcrumbs,
            headline,
            subHeadline,
            companies,
            seoTextBottom,
        } = this.props.companyOverview;

        const { deviceType, discountThreshold } = this.props.pageData;

        const isMobile = deviceType === 'mobile';

        const CompanyOverview = () => {
            if (!companies?.length) return null;

            return isMobile ? (
                <>
                    {companies.map((item, key) => {
                        const companyProps = {
                            data: [item],
                            discountThreshold: discountThreshold,
                        };
                        return (
                            <RecommendationSection
                                key={`Recommendation ${key}`}
                                data={recommendationDescUnderImg(companyProps)}
                                collapsibleComponent={false}
                                wrapperStyles={styles.recommendationWrapper}
                            />
                        );
                    })}
                </>
            ) : (
                <div className="company-overview-page--teasers-wrapper">
                    {companies.map((item, index) => (
                        <div className="recommendation-teaser" key={index}>
                            <a href={item.uri}>
                                <div className="recommendation-teaser--top">
                                    <img src={item.teaserImage} alt="" />
                                    <div>{item.title}</div>
                                </div>
                                <div className="recommendation-teaser--bottom">
                                    <div className="recommendation-teaser--bottom__description">
                                        <div
                                            className="no-margin-on-children"
                                            dangerouslySetInnerHTML={{
                                                __html: `${item.shipCountString}${item.teaserDescription}`,
                                            }}
                                        />
                                    </div>
                                    <div className="recommendation-teaser--bottom__price">
                                        <PriceWithDiscount
                                            price={item.price}
                                            discount={item.discount}
                                            currency={this.props.pageData.appConfig.defaultCurrency}
                                            discountThreshold={
                                                this.props.pageData.discountThreshold
                                            }
                                            hasPP={true}
                                        />
                                    </div>
                                </div>
                            </a>
                        </div>
                    ))}
                </div>
            );
        };

        const MoreInfo = () => {
            if (!seoTextBottom) return null;

            return isMobile ? (
                <CollapsibleText text={seoTextBottom} defaultExpanded={false} />
            ) : (
                <FurtherInfo defaultExpanded={false} description={seoTextBottom} />
            );
        };

        return (
            <div className="company-overview-page">
                <div className="company-overview-page--container">
                    {!isMobile && (
                        <Breadcrumbs
                            className="onlyTabletUp noLateralPadding"
                            breadcrumbs={breadcrumbs}
                        />
                    )}
                    <OverviewPageHeader title={headline} subTitle={subHeadline} />

                    <CompanyOverview />

                    <MoreInfo />
                    {isMobile && <Breadcrumbs className="onlyMobile" breadcrumbs={breadcrumbs} />}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IState): StateProps => ({
    pageData: state.pageData,
    companyOverview: state.companyOverviewPage,
});

export const CompanyOverviewPage = connect(mapStateToProps)(CompanyOverviewPageClass);
export default CompanyOverviewPage;
